import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { ButtonComponent } from '@pure/hive';
import { IRichBlockAction, RichBlockActionActivation, toRichBlockActionActivation } from '@pure1/data';

/**
 * One block action, rendered as a button, emitting the activation and nothing else.
 *
 * The action-handler seam, not the `actions` block renderer: it deliberately knows nothing about
 * how an action is fulfilled. Shared because `callout` and `task_list` both carry inline actions.
 */
@Component({
    selector: 'copilot-rich-block-action-button',
    templateUrl: './rich-block-action-button.component.html',
    styleUrl: './rich-block-action-button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
    imports: [ButtonComponent],
})
export class RichBlockActionButtonComponent {
    readonly action = input.required<IRichBlockAction>();

    readonly activate = output<RichBlockActionActivation>();

    /** `primary` is the only emphasis a block may declare; everything else is a secondary button. */
    protected readonly emphasis = computed(() => (this.action().emphasis === 'primary' ? 'primary' : 'secondary'));

    /** What pressing the button does, in the reader's terms: asks the assistant, or leaves the chat. */
    protected readonly kindTag = computed(() => (this.action().kind === 'navigate' ? 'nav' : 'prompt'));

    protected activateAction(): void {
        this.activate.emit(toRichBlockActionActivation(this.action()));
    }
}
